'use client'

import { ContentForm } from 'features/generator/ContentForm'
import {
	qrNameFormConfig,
	TQrContentFormSection,
	welcomeScreenFormConfig,
} from 'features/generator/contentFormSections'
import { menuFormConfig } from 'features/generator/contentFormSections/MenuForm/MenuForm'
import { restaurantInfoFormConfig } from 'features/generator/contentFormSections/MenuForm/RestaurantInfo'
import { QR_TYPE, TContentFormProps } from 'features/generator/generatorTypes'
import { useTranslations } from 'next-intl'

import { contentDesignFormConfig } from '@/content-from-sections/client'

export const MenuContentForm = (props: TContentFormProps) => {
	const t = useTranslations()

	const config = {
		formSectionList: [
			contentDesignFormConfig(t),
			restaurantInfoFormConfig(t),
			menuFormConfig(t),
			welcomeScreenFormConfig(t),
			qrNameFormConfig(t),
		] satisfies TQrContentFormSection[],
	}

	return <ContentForm config={config} qrType={QR_TYPE.Menu} {...props} />
}
